var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchGlobeSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st0, .st1, .st2 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 48px;\n      }\n\n      .st0, .st2 {\n        stroke: #d47500;\n      }\n\n      .st1 {\n        stroke: #336;\n      }\n\n      .st1, .st2 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M716,395.2c0-63.3-18.8-125.2-53.9-177.8-35.2-52.6-85.1-93.6-143.6-117.9-58.5-24.2-122.8-30.6-184.9-18.2-62.1,12.3-119.1,42.8-163.8,87.6-44.8,44.8-75.2,101.8-87.6,163.8-12.3,62.1-6,126.4,18.2,184.9,24.2,58.5,65.2,108.5,117.9,143.6,52.6,35.2,114.5,53.9,177.8,53.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76,395.2h640"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M396,715.2c-61.8,0-112-143.4-112-320s50.2-320,112-320,112,143.4,112,320"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.3,634.2c78.8,0,142.6-63.8,142.6-142.6s-63.8-142.6-142.6-142.6-142.6,63.8-142.6,142.6,63.8,142.6,142.6,142.6Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M702,694.2l-88-87.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGlobeSvgrepoCom);
export default __webpack_public_path__ + "static/media/search-globe-svgrepo-com.ce4e15ea4cf3b8ce92012fec85d88bba.svg";
export { ForwardRef as ReactComponent };